import { connect } from 'react-redux';

import ChecklistCompleteTaskButton from './ChecklistCompleteTaskButton';

import * as checklistV2Actions from '../../../../actions/ChecklistV2Actions';

import {
  getActiveTaskId,
  getChecklistTaskCompletedAtByTaskId,
} from '../../../../selectors/checklist/checklistSelectors';

const mapStateToProps = state => {
  const taskId = getActiveTaskId(state) || '';
  const taskCompleted = getChecklistTaskCompletedAtByTaskId(state, taskId);

  return {
    taskId,
    taskCompleted: Boolean(taskCompleted),
  };
};

const mapDispatchToProps = dispatch => ({
  onClick: taskId =>
    dispatch(checklistV2Actions.toggleCompleted(taskId))
      .then(taskJson => {
        dispatch(checklistV2Actions.emitConfMsg(taskJson.completed_at));

        return taskJson;
      })
      .then(taskJson => {
        if (taskJson.completed_at) dispatch(checklistV2Actions.handleGoToNextTask(taskJson.id));

        return taskJson;
      }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChecklistCompleteTaskButton);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistCompleteTaskButton/index.js